module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_07@2x-2d1ef874a73a98efae22b90b3fe9c3ac.jpg";